import { ReactElement } from 'react';

import cn from '@/helpers/utils/classNames';

import { useDropDownContext } from '../context';
import DropdownLink, { DropdownLinks } from '../DropdownLink';
import DropdownSubMenu from '../DropdownSubMenu';

export interface DropdownColumnProps {
  className?: string;
  children: ReactElement<DropdownLinks> | ReactElement<DropdownLinks>[];
}

export default function DropdownColumn(props: DropdownColumnProps) {
  const { children, className } = props;

  useDropDownContext();

  return (
    <ul
      className={cn(
        'v2-absolute v2-z-50 v2-mt-4 v2-w-max v2-min-w-[210px] v2-rounded-[4px] v2-bg-white v2-py-6 v2-text-sm v2-font-sweet-sans-pro v2-font-normal v2-shadow-[0_-5px_15px_0px_rgba(0,0,0,0.1)] v2-outline-1 px-6',
        className
      )}
    >
      {children}
    </ul>
  );
}

DropdownColumn.ColumnItem = DropdownLink;
DropdownColumn.SubMenu = DropdownSubMenu;
